import { urls } from "../Utils/Urls";
import { Request } from "./Request";

export const getFarmerprofile = async (auth_token, userUuid) => {
  try {
    const requestObject = {
      url: urls.farmer_profile,
      data: {
        RequestInfo: {
          authToken: auth_token || localStorage.getItem("DfsWeb.access-token"),
        },
        userUuid:
          userUuid ||
          (localStorage.getItem("DfsWeb.user-info") &&
            JSON.parse(localStorage.getItem("DfsWeb.user-info")).uuid),
      },
      params: {
        tenantId: "br",
      },
    };
    const response = await Request(requestObject);
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getAppliedSchemes = async () => {
  try {
    const response = await Request({
      url: urls.farmer_applied_schemes,
      data: {
        RequestInfo: {
          authToken: localStorage.getItem("DfsWeb.access-token"),
        },
      },
      params: {
        farmerId: localStorage.getItem("DfsWeb.farmerId"),
      },
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

/**
 * Farmer/CITIZEN recommended schemes. The shared `Request` wrapper injects
 * `RequestInfo.authToken` from `DfsWeb.access-token`, so the body is just an
 * empty envelope — the backend derives the farmer from the token (no farmerId /
 * dbtId in the body). Produces exactly:
 *   POST /farmer-schemes/schemes/v1/recommended/_search?tenantId=br
 *   { "RequestInfo": { "authToken": "<DfsWeb.access-token>" } }
 * (AGENT uses the farmer-context OTP path, not this call — see useRecommendedSchemes.)
 */
export const getRecommendedSchemes = async () => {
  try {
    const response = await Request({
      url: urls.Schemes_Recommended,
      data: { RequestInfo: {} },
      params: { tenantId: "br" },
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const getApplicationStatus = async (applicationId) => {
  try {
    const response = await Request({
      url: urls.farmer_application_status,
      data: {
        RequestInfo: {
          authToken: localStorage.getItem("DfsWeb.access-token"),
        },
      },
      params: {
        dfsSchemeApplicationId: applicationId,
      },
    });
    return response;
  } catch (error) {
    return error.response;
  }
};
